export default __webpack_public_path__ + "static/media/paypal-secured-payment.4dd0da9d.png";